import { observer } from "mobx-react";
import React, { Component } from "react";
import Layouter from "../../containers/Layouter";
import { MainStore } from "../../stores/MainStore";
import Footer from "../Footer";
import Header from "../Header";
import NotFound from "../NotFound";
import DetailsBody from "./DetailsBody";
import classes from "./styles.module.scss";

interface IProps {
  store: MainStore;
}
interface IState {}
@observer
class Details extends Component<IProps, IState> {
  render() {
    const { store } = this.props;
    const { selectedState } = store;
    return (
      <div className={classes.Details}>
        {selectedState && !selectedState.disabled ? (
          <Layouter staticFooter>
            <Header store={store} title={"details.title"} />
            <DetailsBody store={store} />
            <Footer />
          </Layouter>
        ) : (
          <NotFound store={this.props.store} />
        )}
      </div>
    );
  }
}
export default Details;
